import { isArray } from '@cutwise/utils';

import LocalStorageDriver from '@/common/services/session/LocalStorageDriver';
import UserSessionDataManager from '@/common/services/session/UserSessionDataManager';
import Storage, { KEY_PINNED_ITEMS } from '@/common/services/Storage';
import { PinnedCarbonProject } from '@/forwarding/entities/PinnedItem/PinnedCarbonProject';
import { PinnedItem, PinnedItemModel, PinnedItemType } from '@/forwarding/entities/PinnedItem/PinnedItem';
import { PinnedProduct } from '@/forwarding/entities/PinnedItem/PinnedProduct';
import { PinnedUrl } from '@/forwarding/entities/PinnedItem/PinnedUrl';

class PinnedItemsStorage {
  private static userSessionDataManager = new UserSessionDataManager(new LocalStorageDriver());

  static get(): PinnedItem[] {
    const value = Storage.getObject(KEY_PINNED_ITEMS, Storage.STORAGE_LOCAL);

    return PinnedItemsStorage.fromJson(value);
  }

  static onKeyChange(callback: (value: PinnedItem[]) => void) {
    PinnedItemsStorage.userSessionDataManager.onKeyChange(KEY_PINNED_ITEMS, (value) => {
      callback(PinnedItemsStorage.fromJson(value));
    });
  }

  static save(state: PinnedItem[]) {
    const models = state.map((item) => item.toModel());

    Storage.saveObject(KEY_PINNED_ITEMS, models, Storage.STORAGE_LOCAL);
  }

  private static fromJson(value: unknown): PinnedItem[] {
    return isArray<PinnedItemModel>(value) ? value.map(PinnedItemsStorage.toPinnedItem) : [];
  }

  private static toPinnedItem = (model: PinnedItemModel) => {
    switch (model.type) {
      case PinnedItemType.CarbonProject:
        return new PinnedCarbonProject({ id: model.projectId });
      case PinnedItemType.Product:
        return new PinnedProduct({ id: model.productId, type: model.productType });
      case PinnedItemType.Url:
        return new PinnedUrl({ id: model.driveItemId, url: model.url });
    }
  };
}

export default PinnedItemsStorage;
